import { render, staticRenderFns } from "./batch-form-pm-ck.vue?vue&type=template&id=01987492&scoped=true&"
import script from "./batch-form-pm-ck.vue?vue&type=script&lang=js&"
export * from "./batch-form-pm-ck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01987492",
  null
  
)

export default component.exports